module.exports = __webpack_public_path__ + "img/ai-img-bg.c5673b12.png";